/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateReferralStatusRequest
 */
export interface UpdateReferralStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateReferralStatusRequest
     */
    status: UpdateReferralStatusRequestStatusEnum;
    /**
     * Required when status is 'confirmed'. The facility being confirmed.
     * @type {string}
     * @memberof UpdateReferralStatusRequest
     */
    facility_id?: string;
    /**
     * Required when status is 'closed'.
     * @type {string}
     * @memberof UpdateReferralStatusRequest
     */
    close_reason?: UpdateReferralStatusRequestCloseReasonEnum;
}


/**
 * @export
 */
export const UpdateReferralStatusRequestStatusEnum = {
    Confirmed: 'confirmed',
    Closed: 'closed'
} as const;
export type UpdateReferralStatusRequestStatusEnum = typeof UpdateReferralStatusRequestStatusEnum[keyof typeof UpdateReferralStatusRequestStatusEnum];

/**
 * @export
 */
export const UpdateReferralStatusRequestCloseReasonEnum = {
    ConfirmedElsewhere: 'confirmed_elsewhere',
    Declined: 'declined',
    Lost: 'lost',
    Withdrawn: 'withdrawn'
} as const;
export type UpdateReferralStatusRequestCloseReasonEnum = typeof UpdateReferralStatusRequestCloseReasonEnum[keyof typeof UpdateReferralStatusRequestCloseReasonEnum];


/**
 * Check if a given object implements the UpdateReferralStatusRequest interface.
 */
export function instanceOfUpdateReferralStatusRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function UpdateReferralStatusRequestFromJSON(json: any): UpdateReferralStatusRequest {
    return UpdateReferralStatusRequestFromJSONTyped(json, false);
}

export function UpdateReferralStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReferralStatusRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'close_reason': !exists(json, 'close_reason') ? undefined : json['close_reason'],
    };
}

export function UpdateReferralStatusRequestToJSON(value?: UpdateReferralStatusRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'facility_id': value.facility_id,
        'close_reason': value.close_reason,
    };
}

